import { UserBase } from '../user';
import { createEventTracker } from '../util';
import { MetricAlertSaveAnalytics, MetricAlertViewedAnalytics } from './types';

export const trackMetricAlertSaved =
  createEventTracker<MetricAlertSaveAnalytics>('Metric Alert Saved');

export const trackMetricAlertViewed =
  createEventTracker<MetricAlertViewedAnalytics>('Metric Alert Viewed');

export const trackAtAlertLimit = createEventTracker<UserBase>('At Alert Limit');
